import { core_apimessages_Money } from '@reverbdotcom/commons/src/gql/graphql';

export interface ICustomsSignerInfo {
  customsSigner: string;
  certifiesAccuracy: boolean;
}

export interface ICustomsInfo {
  orderId: string;
  description: string;
  shortDescription: string;
  tariffNumber: string;
  categoryName: string;
  declaredValue: core_apimessages_Money;
  countryOfOrigin: string;
  quantity: number;
}

export function buildCustomsInfoFromOrders(orders): ICustomsInfo[] {
  return orders.map((order) => {
    return ({
      orderId: order.id,
      description: order.customsInfo.description,
      shortDescription: order.customsInfo.shortDescription,
      tariffNumber: order.customsInfo.tariffNumber,
      categoryName: order.customsInfo.categoryName,
      declaredValue: order.settlementAmountProductSubtotal,
      countryOfOrigin: order.customsInfo.countryOfOrigin,
      quantity: order.quantity,
    });
  });
}

export function buildCustomsSignerInfo(): ICustomsSignerInfo {
  return {
    customsSigner: '',
    certifiesAccuracy: false,
  };
}

export function findCustomsInfoForOrder(orderId: string, customsInfo: ICustomsInfo[]) {
  return (
    customsInfo.find((customsInfo) => {
      return (customsInfo.orderId === orderId);
    })
  );
}
